module.exports = __webpack_public_path__ + "img/arrow-new.0fd5165c.svg";